import React from 'react'

import { Form, Col } from '_zari/core'

import TiposConstant from 'constants/tipoDocumentoPlantilla'

import { IdGen } from 'utils'

const TipoDocumentoFormGroup = ({ value, onChange }) => {
  return (
    <Form.Group>
      <Form.Label text='DOCUMENTO' htmlFor='select-tipoDocumento' sm={5} md={4} alignRightAt='sm' />
      <Col sm={7} md={8}>
        <Form.Select
          id='select-tipoDocumento'
          name='select-tipoDocumento'
          value={value}
          onChange={onChange}
        >
          <option value=''>Seleccionar</option>
          {TiposConstant.__array.map(x => (
            <option key={IdGen.newId()} value={x.id}>
              {x.nombre}
            </option>
          ))}
        </Form.Select>
      </Col>
    </Form.Group>
  )
}

export default TipoDocumentoFormGroup
